import { render, staticRenderFns } from "./CallStateItem.vue?vue&type=template&id=ddec0ade"
import script from "./CallStateItem.vue?vue&type=script&lang=js"
export * from "./CallStateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports